import { Box } from '@mui/material';
import {
  PatientChallengeTable,
  PatientCompletedTable,
  PatientEncounterTable,
  PatientExerciseTable,
  PatientGoalTable,
  PatientResourceTable,
} from 'components/organisms';
import React from 'react';

import { PatientProfileTableViewProps } from './types';

export const PatientProfileTableView = ({
  patientId,
  therapistId,
}: PatientProfileTableViewProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <PatientExerciseTable patientId={patientId} />
      <PatientChallengeTable patientId={patientId} />
      <PatientResourceTable patientId={patientId} />
      <PatientGoalTable patientId={patientId} />
      <PatientEncounterTable patientId={patientId} therapistId={therapistId} />
      <PatientCompletedTable patientId={patientId} />
    </Box>
  );
};
